<!-- src/components/SelectComponent.vue -->
<script setup lang="ts">
import { provide, ref } from 'vue';
import CaretIcon from '@/assets/svg/CaretIcon.vue';
import Dropdown from '@/components/DropdownComponent.vue';

const props = defineProps<{
  modelValue: string | number;
  label?: string;
}>();
const emit = defineEmits<{
  (e: 'update:modelValue', v: string | number): void;
}>();

const dropdownRef = ref<InstanceType<typeof Dropdown> | null>(null);

// the function we’ll hand down to every OptionComponent
function selectAndClose(value: string | number) {
  emit('update:modelValue', value);
  if (dropdownRef.value) dropdownRef.value.isDropdownOpen = false;
}

// make it available to descendants
provide('selectFn', selectAndClose);
</script>

<template>
  <Dropdown ref="dropdownRef" class="text-xs">
    <template #menu>
      <div
        class="px-4 py-1 cursor-pointer border-2 border-gray-200 select-component-menu flex items-center justify-between"
      >
        <h1>{{ label ? label : props.modelValue }}</h1>
        <CaretIcon class="caret-icon" />
      </div>
    </template>
    <template #dropdown>
      <div class="bg-white shadow-md max-h-64 overflow-scroll w-full">
        <!-- render whatever OptionComponents were passed in -->
        <slot />
      </div>
    </template>
  </Dropdown>
</template>

<style scoped>
:deep(.select-component-menu) .caret-icon {
  width: 14px !important;
  min-width: 14px !important;
  max-width: 14px !important;
  line-height: 14px !important;
  padding: 0 !important;
}
</style>
